<template>
	<div class="content background1" style="height: 99%;display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<tree :dataTree="treeData" @getDeviceMes="getDeviceMes" :treeType="0"></tree>
						</el-tab-pane>
						<el-tab-pane :label="this.$t('label_161')" name="second">
							<tree :dataTree="treeData2" @getDeviceMes="getDeviceMes" :treeType="1"></tree>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{$t('label_88')}}</p>
						<div class="chooseBox" style="height: 110px;">
							<div class="selectBox a" style="height:0px;width: 100%; display: table;">
								<el-tabs v-model="activeNameSpot" @tab-click="handleClickSpot">
									<el-tab-pane :label="$t('label_91')" name="spot" v-if="MenuRoleList.indexOf('123')>=0"></el-tab-pane>
									<el-tab-pane :label="$t('label_94')" name="pro" v-if="MenuRoleList.indexOf('125')>=0"></el-tab-pane>
								</el-tabs>
							</div>
              <!-- 上 -->
              <div style="width: 100%;position:relative;">
							<div class="selectBox" style="margin-top: -10px;float: left;">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 250px;">
											<p>{{$t('label_483')}}</p>
										</div>
										<div class="select" style="width:380px">
											<el-input v-model="code" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose" style="width: 400px">
										<div class="selectText" style="width: 210px;">
											<p>{{$t('label_596')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-date-picker v-model="Readytime" type="daterange" format="yyyy-MM-dd" value-format='yyyy-MM-dd'
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
											</el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox buttonBoxRight" style="margin-top: -3px;">
								<div >
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize})" style="margin-right:10px;"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
              </div>
						</div>
						<div class="spotMes3Box" v-if="activeNameSpot=='spot'" style="position: relative">
							<div class="tableMin" style="height: 100%;">
								<div class="tableList" style="height: 100%;">
									<div class="buttonBox" style="float: left">
										<div>
<!--											<div class="chooseButton searchButton" @click="excel" v-if="MenuRoleList.indexOf('124')>=0" style="margin-left: 0px;">-->
<!--												<i class="el-icon-download"></i>{{$t('btn_10')}}-->
<!--											</div>-->
										</div>
									</div>
									<div class="tableNum">
										<p class="p4"><img src="../../assets/img/spot/checkNum.png" style="width: 25px; height: 25px;" />
											{{statusNumList.statusAll}}</p>
										<p class="p4"><img src="/static/img/zhengchang.png" style="width: 25px; height: 25px;" />
											{{statusNumList.status2}}</p>
										<p class="p4" :class="statusNumList.status3>0?'louNum':''"><img src="/static/img/yuqiwei.png"
											 style="width: 25px; height: 25px;" /> {{statusNumList.status3}}</p>
										<p class="p4"><img src="/static/img/yuqi.png" style="width: 25px; height: 25px;" />
											{{statusNumList.status4}}</p>

										<p class="p4" :class="statusNumList.status0>0?'louNum':''"><img src="/static/img/shangwei.png"
											 style="width: 25px; height: 25px; transform: scale(1.2);" />
											{{statusNumList.status0}}</p>
										<p class="p4"><img src="/static/img/jinxing.png" style="width: 25px; height: 25px; transform: scale(1.2);" />
											{{statusNumList.status1}}</p>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData1" highlight-current-row border style="width: 100%;margin: 10px 0"
									 height="85.9%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}" @row-click="handler">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="deviceName" :label="$t('label_593')" align="center">
											<template slot-scope="scope">
												<p class="tableMiTitle">
													{{scope.row.superior}}<br>
													{{scope.row.name}}<br>
													{{scope.row.code}}
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="num5" :label="$t('label_479')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num5}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num2" :label="$t('label_619')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num2}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num3" :label="$t('label_623')" align="center" width="140">
											<template slot-scope="scope">
												<p :class="scope.row.num3>0?'louNum':''">{{scope.row.num3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num4" :label="$t('label_627')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num4}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num0" :label="$t('label_611')" align="center" width="140">
											<template slot-scope="scope">
												<p :class="scope.row.num0>0?'louNum':''">{{scope.row.num0}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num1" :label="$t('label_615')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num1}}</p>
											</template>
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModel1" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="search"></Page>
								</div>
							</div>
						</div>
						<div class="spotMes3Box" v-if="activeNameSpot=='pro'" style="position: relative">
							<div style="height: 100%;">
								<div class="tableList" style="height: 100%;">
									<div class="buttonBox" style="float: left">
										<div>
<!--											<div class="chooseButton searchButton" @click="excel" v-if="MenuRoleList.indexOf('126')>=0"  style="margin-left: 0px;">-->
<!--												<i class="el-icon-download"></i>{{$t('btn_10')}}-->
<!--											</div>-->
										</div>
									</div>
									<div class="tableNum">
										<p class="p4"><img src="../../assets/img/spot/checkNum.png" style="width: 25px; height: 25px;" />
											{{statusNumList.statusAll}}</p>
										<p class="p4"><img src="/static/img/zhengchang.png" style="width: 25px; height: 25px;" />
											{{statusNumList.status2}}</p>
										<p class="p4" :class="statusNumList.status3>0?'louNum':''"><img src="/static/img/yuqiwei.png"
											 style="width: 25px; height: 25px;" /> {{statusNumList.status3}}</p>
										<p class="p4"><img src="/static/img/yuqi.png" style="width: 25px; height: 25px;" />
											{{statusNumList.status4}}</p>
										<p class="p4" :class="statusNumList.status0>0?'louNum':''"><img src="/static/img/shangwei.png"
											 style="width: 25px; height: 25px; transform: scale(1.2);" />
											{{statusNumList.status0}}</p>
										<p class="p4"><img src="/static/img/jinxing.png" style="width: 25px; height: 25px; transform: scale(1.2);" />
											{{statusNumList.status1}}</p>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable2" :data="tableDataInfo" highlight-current-row border style="width: 100%;margin: 10px 0"
									 height="86%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}" @row-click="handler">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="maintainName" :label="$t('label_483')" align="center" width="200">
											<template slot-scope="scope">
												<p class="">
													{{scope.row.maintainName}}
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="enum" :label="$t('label_477')" align="center">
											<template slot-scope="scope">
												<p>{{scope.row.enum}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num" :label="$t('label_98')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num2" :label="$t('label_619')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num2}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num3" :label="$t('label_623')" align="center" width="140">
											<template slot-scope="scope">
												<p :class="scope.row.num3>0?'louNum':''">{{scope.row.num3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num4" :label="$t('label_627')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num4}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num0" :label="$t('label_611')" align="center" width="140">
											<template slot-scope="scope">
												<p :class="scope.row.num0>0?'louNum':''">{{scope.row.num0}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num1" :label="$t('label_615')" align="center" width="140">
											<template slot-scope="scope">
												<p>{{scope.row.num1}}</p>
											</template>
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModel2" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="search"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/maintainTree";
	import maintenance from "@/assets/js/maintenance/maintenance.js";
	export default {
		name: 'spotCountPage',
		components: {
			Page,
			tree,
		},
		data() {
			return {
				code: '',
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				getTreeMes: '1',
				checked: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				height: 480,
				tableDataTree: [],
				MenuRoleList: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableData1: [],
				tableDataInfo: [],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				statusNumList: {
					statusAll:0,
					status0:0,
					status1:0,
					status2:0,
					status3:0,
					status4:0
				},
				type: '',
				id: '',
				name: '',
				deviceDetailMes: {},
				checkInfo:{},
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			handleClickSpot(tab, event) {
				this.checkInfo={};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				})
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			handler(row) {
				// this.type = 1;
				// this.id = row.equipmentId;
				this.checkInfo=row
				// if (this.activeNameSpot == 'pro') {
				// 	this.name = row.maintainName;
				// }
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					if(this.activeNameTree == 'first'){
						this.type = 0;
						this.id = '';
					}else{
						this.type = 2;
						this.id = '';
					}

					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.type = data.type;
					this.id = data.id;
					this.name = data.name;
					this.deviceDetailMes = data;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				}
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.dialogSpotResult = false;
				this.dialogSpotBatchTimeEdit = false;
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			tableDataTreeInfoEdit() {
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.dialogDeviceSpot = true;
					this.tableDataTreeEdit = this.tableDataTreeInfo
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			handleCurrentChangeTreeTime(info) {},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			search(param) {
				var dataParam = {
					beginTime: this.Readytime[0],
					endTime: this.Readytime[1],
					code: this.code,
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id,
				}
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				if (this.activeNameSpot == 'pro') {
					this.searchPage2(newParam);
				} else {
					this.searchPage(newParam);
				}
				if (this.activeNameSpot == 'pro') {
					this.searchStauts(newParam,2);
				} else {
					this.searchStauts(newParam,1);
				}

			},
			searchPage(param) {
				maintenance.getCount(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData1 = data.data.records
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						if (this.tableData1.length > 0) {
							this.statusNumList.statusAll=0;
							this.statusNumList.status0=0;
							this.statusNumList.status1=0;
							this.statusNumList.status2=0;
							this.statusNumList.status3=0;
							this.statusNumList.status4=0;
							for (let i = 0; i < this.tableData1.length; i++) {
								this.statusNumList.statusAll += this.tableData1[i].num5;
								this.statusNumList.status2 += this.tableData1[i].num2;
								this.statusNumList.status3 += this.tableData1[i].num3;
								this.statusNumList.status4 += this.tableData1[i].num4;
								this.statusNumList.status0 += this.tableData1[i].num0;
								this.statusNumList.status1 += this.tableData1[i].num1;
							}
						}
						console.log(this.statusNumList);
						this.$refs['pageModel1'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchPage2(param) {

				maintenance.getCount2(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataInfo = data.data.records
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						if (this.tableDataInfo.length > 0) {
							this.statusNumList.statusAll=0;
							this.statusNumList.status0=0;
							this.statusNumList.status1=0;
							this.statusNumList.status2=0;
							this.statusNumList.status3=0;
							this.statusNumList.status4=0;
							for (let i = 0; i < this.tableDataInfo.length; i++) {
								this.statusNumList.statusAll += this.tableDataInfo[i].num;
								this.statusNumList.status2 += this.tableDataInfo[i].num2;
								this.statusNumList.status3 += this.tableDataInfo[i].num3;
								this.statusNumList.status4 += this.tableDataInfo[i].num4;
								this.statusNumList.status0 += this.tableDataInfo[i].num0;
								this.statusNumList.status1 += this.tableDataInfo[i].num1;
							}
						}
						console.log(this.statusNumList);
						this.$refs['pageModel2'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchStauts(param,type) {
				maintenance.getStatus2(param,type).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						if(data.data==null){
							this.statusNumList.statusAll=0
							this.statusNumList.status0=0
							this.statusNumList.status1=0
							this.statusNumList.status2=0
							this.statusNumList.status3=0
							this.statusNumList.status4=0
						}else{
						// this.statusNumList = data.data
						}
					}
				}).catch((response) => {
					this.statusNumList.statusAll=0
					this.statusNumList.status0=0
					this.statusNumList.status1=0
					this.statusNumList.status2=0
					this.statusNumList.status3=0
					this.statusNumList.status4=0
					console.log(response)
				})
			},
			excel() {
				if ((this.checkInfo.equipmentId != '' && this.checkInfo.equipmentId != null )||(this.checkInfo.maintainName != '' && this.checkInfo.maintainName != null)) {
					if (this.activeNameSpot == 'pro') {
						window.location.href = encodeURI(this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel2?time=' +
							this.Readytime[0].substring(0, 4) + "&type=" + this.type + "&id=" + this.id + "&name=" + this.checkInfo.maintainName.replaceAll('#', '%23'));
					} else {
						window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMaintainRecord/excel1?time=' + this.Readytime[0].substring(0, 4) + "&type=1"  + "&id=" + this.checkInfo.equipmentId;
					}
				} else {
					utils.messageAlert(this.$t('请选择要导出的数据'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				var time = (new Date);
				time.setMonth(time.getMonth()-1);
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},
		created() {
			this.Readytime = [this.getBeforeTime(), this.getNowTime()]
			// this.Readytime = [new Date().getFullYear() + "-01-01", this.getNowTime()];
			this.search({
				pageNum: 1,
				pageSize: this.pageSize,
			});
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style>
	.maintainBox {
		width: 100%;
	}

	.a .el-tabs .el-tabs__content {
		height: 0px;
	}

	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
 /* .selectSpot2{
    height: 675px;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/maintainCountPage.vue